module.exports = __webpack_public_path__ + "678215886d621a901c991adfc228874e.png";